import React, { useEffect, useState } from 'react'
import styles from './Payment.module.css'
import I18n from 'i18n-js'
import Grid from '@material-ui/core/Grid'
import Container from '@material-ui/core/Container'
import { ReactComponent as Success } from '../../assets/svgs/success.svg'
import { ReactComponent as Failed } from '../../assets/svgs/failed.svg'
import ConsultantCardProfile from '../Consultant/components/ConsultantCardProfile/ConsultantCardProfile'
import { makeStyles } from '@material-ui/core/styles'
import ReserveInfo from './components/ReserveInfo'
import axios from 'axios'
import { useLocation } from 'react-router-dom'
import { Button } from '@material-ui/core'
import consultants from '../../assets/translations/fa/consultants'
import { useSelector } from 'react-redux'

const useStyles = makeStyles((theme) => ({
	root: {
		minWidth: 275,
		maxWidth: 744,

		[theme.breakpoints.up('md')]: {
			marginTop: 113
		},
		[theme.breakpoints.down('sm')]: {
			marginTop: 32
		}
	},

	header: {}
}))

function useQuery() {
	return new URLSearchParams(useLocation().search)
}

const Payment = (props) => {
	const classes = useStyles()
	const queryStrings = useQuery()

	const [response, setResponse] = useState()
	const {
		language,
		currency,
		timezone
	} = useSelector(state => state.SettingsReducer)

	useEffect(() => {
		const queries = {}
		queryStrings.forEach((param, key) => {
			queries[key] = param
		})

		axios.post(`https://panel.betterpro.app/api/payment/verify`, queries, {
				headers: {
					'X-Accept-Language': language,
					'X-Currency': currency,
					'X-Timezone': timezone
				}
			})
			.then(({ data }) => {
				setResponse(data)
			})
	}, [])

	return (
		<Container className={classes.root}>
			<Grid alignItems="center" xs={12} md={12}>

				{
					response && (
						<>
							{
								response.success && (
									<Grid  justify={'center'} container className={styles.Payment}>
										<Grid item md={6} xs={12} className={styles.success}>
											<Success with={80} height={60} fill={'#CACDD9'} style={{ marginLeft: 8 }}/>
											<h2 style={{ color: '#64A53B',fontSize:16 }}>{I18n.t('consultant.successPayment')}</h2>
										</Grid>

										<Grid item xs={12} md={12}>
											<ReserveInfo reserve={response.content}/>
										</Grid>
									</Grid>
								)
							}

							{
								!response.success && (
									<div className={styles.failedPayment}>
										<div className={styles.danger}>
											<Failed with={80} height={60} fill={'#CACDD9'} style={{ marginLeft: 8 }}/>
											<p style={{ color: '#DE5354'}}>{response.message}</p>
											<div className={styles.button} >
												<a  className={styles.buttonTitle} href={`/consultants/${response.content.counseling_center_username}/${response.content.consultant_username}`}>
													{I18n.t('consultant.failedPaymentButton')}
												</a>
											</div>
										</div>
									</div>
								)
							}
						</>
					)
				}
			</Grid>
		</Container>
	)
}

export default Payment
